import {Graphics} from "pixi.js";
import {inches, lineBlueHeavy} from "../const";
import {HardwareCategoryFields, hasCategory} from "./hardwareGlyphs/HardwareGlyph";
import {KICK_PLATE_HEIGHT, PLATE_EDGE_INSET} from "./hardwareGlyphs/ProtectionPlate";

// a kick plate, for cosmetics only: centred across the leaf with its bottom edge the
// standard clearance above the finished floor. Fixed size and place (it is not a placed
// item), drawn when the opening's hardware group has one (see hasKickPlate).
export const KICK_PLATE_ABOVE_FLOOR = 3 * inches;
const OUTLINE = 0.25 * inches;

// seen from the latch edge: the plate lying on the face, drawn heavier than real so it shows.
const PLATE_THICKNESS = 0.25 * inches;

// the face a kick plate mounts on: the push face.
export const KICK_PLATE_FACE = "push";

export function isKickPlate(item: HardwareCategoryFields): boolean {
    return hasCategory(item, "Kick Plate");
}

export function hasKickPlate(items: HardwareCategoryFields[]): boolean {
    return items.some(isKickPlate);
}

// the plate's top in face coords: `bottom` is the bottom of the face, `undercut` the gap
// below it to the finished floor.
function plateTop(bottom: number, undercut: number): number {
    return bottom + undercut - KICK_PLATE_ABOVE_FLOOR - KICK_PLATE_HEIGHT;
}

// draw a kick plate on a leaf face: `left`/`width` span the leaf, `bottom` is the bottom
// of the face, in `g`'s coords.
export function drawDoorKickPlate(g: Graphics, left: number, bottom: number, width: number, undercut: number) {
    const w = Math.max(0, width - 2 * PLATE_EDGE_INSET);
    if(w <= 0) return;

    g.lineStyle(OUTLINE, lineBlueHeavy, 0.5);
    g.beginFill(lineBlueHeavy, 0.1);
    g.drawRect(left + PLATE_EDGE_INSET, plateTop(bottom, undercut), w, KICK_PLATE_HEIGHT);
    g.endFill();
}

// draw a kick plate as seen from the latch edge: `faceX` is the face it mounts on, `out`
// the horizontal direction away from that face, `bottom` the bottom of the face.
export function drawDoorKickPlateEdge(g: Graphics, faceX: number, out: 1 | -1, bottom: number, undercut: number) {
    const x0 = Math.min(faceX, faceX + out * PLATE_THICKNESS);
    g.lineStyle(0);
    g.beginFill(lineBlueHeavy, 0.5);
    g.drawRect(x0, plateTop(bottom, undercut), PLATE_THICKNESS, KICK_PLATE_HEIGHT);
    g.endFill();
}
